import React, { useState, useEffect, useContext } from 'react';
import './style.css';
import QuollScoreBanner from '/src/Components/QuollScoreBanner/QuollScoreBanner';
import { CreateGoogleMapsStreetviewUrl } from '/src/services/CreateGoogleMapsStreetviewUrl';
import MyAccountIconDark from '/src/assets/scenarios-icon-dark.svg';
import MyAccountIconLight from '/src/assets/scenarios-icon-light.svg';
import greenDot from '/src/assets/Green-Dot-4.svg';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { WindowSizeContext } from '/src/App';

const AddressHeader = ({
    propertyData,
    goToPersonalizeAnalysis,
    activeTab
}) => {

    const { deviceType } = useContext(WindowSizeContext);

    const isActiveTabPersonalizeAnalysis = activeTab === 'personalize';

    let icon = MyAccountIconDark;
    if (isActiveTabPersonalizeAnalysis) {
        icon = MyAccountIconLight;
    }

    const [streetviewImageUrl, setStreetviewImageUrl] = useState(null);
    const [addressToDisplay, setAddressToDisplay] = useState(null);

    const loadingStateText = 'Property Loading...';


    const propertyDetails = propertyData?.data?.property_details;
    const latitude = propertyDetails?.lat;
    const longitude = propertyDetails?.long;

    const newStreetviewImageUrl = CreateGoogleMapsStreetviewUrl(latitude, longitude);

    useEffect(() => {

        const propertyDetails = propertyData?.data?.property_details;

        let addressToDisplayInProcess = loadingStateText;
        let streetViewUrlInProcess = null;
        let latitude = null;
        let longitude = null;

        if (propertyDetails) {
            addressToDisplayInProcess = `${propertyDetails.street}, ${propertyDetails.city}, ${propertyDetails.state_short}`;
            setAddressToDisplay(addressToDisplayInProcess);

            latitude = propertyDetails.lat;
            longitude = propertyDetails.long;

            if (latitude && longitude) {
                streetViewUrlInProcess = CreateGoogleMapsStreetviewUrl(latitude, longitude);
                setStreetviewImageUrl(streetViewUrlInProcess);
            }
            // if (streetViewUrlInProcess && !streetviewImageUrl) {
            // }

            // if (addressToDisplayInProcess && addressToDisplay !== loadingStateText) {
            //     console.log('Setting Address to Display:', addressToDisplayInProcess);
            // }
        }



    }, [propertyData]);


    const refineAnalysisIconFilename = "property-explorer-personalize-icon.svg";
    const refineAnalysisIconUrl = CreateCloudfrontUrl(refineAnalysisIconFilename);

    return (
        <div className="address-header-container">
            {deviceType === 'desktop' && (
                <QuollScoreBanner
                    propertyData={propertyData}
                // userPersonalInfo={userPersonalInfo}
                />
            )}
            <div className="individual-property-address-image">
                <div className="individual-property-streetview-wrapper box-shadow-standard">
                    {newStreetviewImageUrl && (
                        <img
                            src={newStreetviewImageUrl}
                            alt="Street View"
                            className="individual-property-streetview-image"
                        />
                    )}
                    <div className="individual-property-streetview-overlay">
                        <h2 className="individual-property-address-text">
                            {addressToDisplay}
                        </h2>
                        {deviceType !== 'desktop' && (
                            <QuollScoreBanner
                                propertyData={propertyData}
                            // userPersonalInfo={userPersonalInfo}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className={`address-header-refine-analysis-button-container ${deviceType}`} onClick={goToPersonalizeAnalysis}>
                <div className={`address-header-refine-analysis-button-container-background ${isActiveTabPersonalizeAnalysis ? 'active' : ''}`}>
                    <img src={greenDot} alt="green dot" />
                </div>
                <div className="address-header-refine-analysis-button-icon-container">
                    <img className={`address-header-refine-analysis-button-icon  ${isActiveTabPersonalizeAnalysis ? 'active' : 'inactive'}`} src={refineAnalysisIconUrl} alt="Quoll Refine Analysis Icon" />
                </div>
            </div>
        </div>
    )
}

export default AddressHeader;